'use es6';

import PropTypes from 'prop-types';
import { Component } from 'react';
import { omit } from 'rich-text-lib/utils/iterables';
import UIPopover from 'UIComponents/tooltip/UIPopover';
import { EARTH_LAYER } from 'HubStyleTokens/sizes';
import withTinyMcePopoverLifecycle from '../hoc/withTinyMcePopoverLifecycle';
import { jsx as _jsx } from "react/jsx-runtime";
class TinyMcePopover extends Component {
  constructor(props) {
    super(props);
    if (props.editor.settings.inline && !!props.editor.settings.canvasToolbar) {
      this.zIndex = Number(EARTH_LAYER);
    }
  }
  render() {
    return /*#__PURE__*/_jsx(UIPopover, Object.assign({}, omit(['editor', 'onRemove', 'zIndex'], this.props), {
      zIndex: this.zIndex
    }));
  }
}
TinyMcePopover.defaultProps = Object.assign({}, omit(['placement', 'arrowSize'], UIPopover.defaultProps), {
  arrowSize: 'medium',
  placement: 'right bottom',
  animateOnToggle: false,
  open: true
});
TinyMcePopover.propTypes = Object.assign({}, UIPopover.propTypes, {
  open: PropTypes.bool
});
export default withTinyMcePopoverLifecycle(TinyMcePopover);